import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, CardHeader, Typography, Tooltip } from "@material-ui/core";
import { Empty, Table } from "antd";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { tooltips } from "../../constants/tooltips";

const TopBehaviours = ({ loops }) => {
  const emptyText = (
    <Empty
      style={{ paddingTop: 10, height: 165 }}
      description={<Typography variant="body1">Not enough data yet to display results</Typography>}
    />
  );

  const columns = [
    {
      title: "Rank",
      dataIndex: "rank",
      width: 100,
    },
    {
      title: "Behavior",
      dataIndex: "title",
    },
  ];

  const tableData = loops.map((loop, index) => ({
    key: index,
    rank: index + 1,
    title: loop.loop_title,
    id: loop.loop_id,
  }));

  const filteredArr = tableData
    .reduce((acc, current) => {
      const x = acc.find((item) => item.id === current.id);
      if (!x) {
        return acc.concat([current]);
      }
      return acc;
    }, [])
    .map((e, index) => ({ ...e, rank: index + 1 }))
    .slice(0, 10);

  return (
    <Card style={{ height: "450px" }}>
      <CardHeader
        title={
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              padding: "8px 0 0 20px",
            }}
          >
            <Typography variant="h6">Top practiced behaviors: Last 30 days</Typography>
            <Tooltip
              title={<Typography>{tooltips.topBehaviours}</Typography>}
              aria-label="journeyChart"
            >
              <HelpOutlineIcon />
            </Tooltip>
          </div>
        }
        style={{ padding: "8px 8px 0 0" }}
      />
      <CardContent>
        <Table
          columns={columns}
          dataSource={filteredArr}
          size="large"
          pagination={{ pageSize: 5 }}
          locale={{ emptyText }}
          rowKey={(record) => record.title + record.key}
        />
      </CardContent>
    </Card>
  );
};

TopBehaviours.propTypes = {
  loops: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default TopBehaviours;
